






























import { Component, Vue } from "vue-property-decorator";
import {mapMutations} from "vuex";
import XButton from "../SimpleButton.vue";

@Component({
  components: { XButton },
  methods: {
    ...mapMutations("cookies", {
      setConfirmed: "setConfirmed",
    }),
  },
})
class Cookies extends Vue {
  [x: string]: any;

  orgName() {
    // VUE_APP_NAME
  }

  cookiesConfirm() {
    this.setConfirmed(true);
  }
}

export default Cookies;
